<template>
  <div class="container">
    <a-drawer
      placement="right"
      :closable="false"
      width="90%"
      height="100%"
      :visible="editVisible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
    >
      <template slot="title">
        <div class="rightTop">
          <div style="font-weight: 700">
            {{ type == 0 ? '预算编辑' : '预算详情' }}
          </div>
        </div>
      </template>
      <div class="center">
        <div class="centerTop">预算年度：{{ rowData.start_year }}</div>
        <div class="centerBottom">
          <div class="centerLeft">
            <div class="top">
              <a-input
                allowClear
                v-model="query.name"
                placeholder="请输入名称"
                @keyup.enter.native="search"
                style="width: 70%;margin-right: 10px;"
                @change="search"
              />
              <a-button type="primary" @click="search"> 查询 </a-button>
              <!-- <a-button type="primary" @click="count"> 点击 </a-button> -->
            </div>
            <div class="millle">
              <div class="middleTop">
                <a-button type="link" @click="companyDetail">{{ rowData.start_year }}年度预算</a-button>
                <!-- <span>2023年度预算</span> -->
                <span @click="addCompeny" v-if="type == 0">
                  <a-icon type="select" style="color: rgb(63, 178, 204)" />
                  选择部门
                </span>
              </div>
              <div class="treeBox">
                <!-- 左侧公司部门 -->
                <a-tree
                  :tree-data="treeData"
                  default-expand-all
                  :replace-fields="deptFields"
                  :selectedKeys='selectedKeys'
                  @select="checkDept"
                  :expanded-keys="expandedKeys1"
                  :auto-expand-parent="autoExpandParent1"
                  @check="search"
                  @expand="onExpand1"
                >
                  <template slot="custom" slot-scope="item">
                    <span class="redd" v-if="item.dept_name.indexOf(searchValue1) > -1">
                      {{ item.dept_name.substr(0, item.dept_name.indexOf(searchValue1)) }}
                      <span style="color: #f50">{{ searchValue1 }}</span>
                      {{ item.dept_name.substr(item.dept_name.indexOf(searchValue1) + searchValue1.length) }}
                    </span>
                    <span v-else>{{ item.dept_name }}</span>
                  </template>
                </a-tree>
              </div>
            </div>
          </div>
          <div class="centerLine"></div>
          <div class="centerRight">
            <div class="top">
              <span>{{ rowData.budget_name }}</span>
              <span v-if="!isSettings">/{{companyDeptName.companyDeptName}}</span>
              <a-button type="link" icon="edit" @click="editTitle" v-if="type == 0 && isSettings"></a-button>
            </div>
            <div class="bottom">
              <div v-if="isSettings">
                <div class="item"><span class="box"></span>预算规则设置</div>
                <div class="itemBox">
                  <span>预算周期转结</span>
                  <div>
                    <a-switch
                      default-checked
                      v-model="rowData.is_cumulative"
                      style="margin-right: 10px"
                      :disabled="type == 1"
                    />打开开关后，当期末未用完的预算自动累计到下期
                  </div>
                </div>
                <div class="itemBox">
                  <span>当预算超额时</span>
                  <div>
                    <a-radio-group v-model="prohibit" >
                      <a-radio v-for="(item, index) in prohibitList" :key="index" :value="item.id">
                        {{ item.title }}
                      </a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
              <div>
                <div class="item"><span class="box"></span>预算额度明细</div>
                <div style="display: flex; justify-content: space-between; padding: 5px 0">
                  <div style="color: #909090">*该预算(首行)不可修改，金额由下级汇总生成总计</div>
                  <a-button
                    @click="addSub"
                    v-if="statisticsList.length && statisticsList.length == 1 && isSettings == false && type == 0"
                    >添加子预算</a-button
                  >
                </div>
                <!-- <button @click="getTree">获取</button> -->
                <div class="tableBox" v-if="type == 1">
                  <a-table :data-source="statisticsList" bordered :pagination="false" :scroll="{ x: 5200, y: 490 }">
                    <a-table-column key="dept_name" data-index="dept_name" title="预算范围">
                      <template scope="text">
                        {{ text }}
                      </template>
                    </a-table-column>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年1月' }}</span>
                      <a-table-column key="month1.budget_quota" data-index="month1.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month1.amount_occupied" data-index="month1.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month1.confirmed_quota" data-index="month1.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month1.remaining_quota" data-index="month1.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年2月' }}</span>
                      <a-table-column key="month2.budget_quota" data-index="month2.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month2.amount_occupied" data-index="month2.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month2.confirmed_quota" data-index="month2.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month2.remaining_quota" data-index="month2.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年3月' }}</span>
                      <a-table-column key="month3.budget_quota" data-index="month3.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month3.amount_occupied" data-index="month3.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month3.confirmed_quota" data-index="month3.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month3.remaining_quota" data-index="month3.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年4月' }}</span>
                      <a-table-column key="month4.budget_quota" data-index="month4.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month4.amount_occupied" data-index="month4.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month4.confirmed_quota" data-index="month4.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month4.remaining_quota" data-index="month4.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年5月' }}</span>
                      <a-table-column key="month5.budget_quota" data-index="month5.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month5.amount_occupied" data-index="month5.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month5.confirmed_quota" data-index="month5.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month5.remaining_quota" data-index="month5.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年6月' }}</span>
                      <a-table-column key="month6.budget_quota" data-index="month6.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month6.amount_occupied" data-index="month6.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month6.confirmed_quota" data-index="month6.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month6.remaining_quota" data-index="month6.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年7月' }}</span>
                      <a-table-column key="month7.budget_quota" data-index="month7.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month7.amount_occupied" data-index="month7.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month7.confirmed_quota" data-index="month7.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month7.remaining_quota" data-index="month7.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年8月' }}</span>
                      <a-table-column key="month8.budget_quota" data-index="month8.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month8.amount_occupied" data-index="month8.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month8.confirmed_quota" data-index="month8.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month8.remaining_quota" data-index="month8.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年9月' }}</span>
                      <a-table-column key="month9.budget_quota" data-index="month9.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month9.amount_occupied" data-index="month9.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month9.confirmed_quota" data-index="month9.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month9.remaining_quota" data-index="month9.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年10月' }}</span>
                      <a-table-column key="month1.10.budget_quota" data-index="month10.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month10.amount_occupied" data-index="month10.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month10.confirmed_quota" data-index="month10.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month10.remaining_quota" data-index="month10.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年11月' }}</span>
                      <a-table-column key="month11.budget_quota" data-index="month11.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month11.amount_occupied" data-index="month11.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month11.confirmed_quota" data-index="month11.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month11.remaining_quota" data-index="month11.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年12月' }}</span>
                      <a-table-column key="month12.budget_quota" data-index="month12.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month12.amount_occupied" data-index="month12.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month12.confirmed_quota" data-index="month12.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month12.remaining_quota" data-index="month12.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                  </a-table>
                </div>
                <div class="tableBox" v-else>
                  <a-table :data-source="statisticsList" bordered :pagination="false" :scroll="{ x: 2200, y: 490 }">
                    <a-table-column key="dept_name" data-index="dept_name" title="预算范围">
                      <template scope="text">
                        {{ text }}
                      </template>
                    </a-table-column>
                    <a-table-column key="month1" data-index="month1" :title="keyYear + '年1月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month1" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month2" data-index="month2" :title="keyYear + '年2月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month2" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month3" data-index="month3" :title="keyYear + '年3月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month3" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month4" data-index="month4" :title="keyYear + '年4月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month4" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month5" data-index="month5" :title="keyYear + '年5月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month5" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month6" data-index="month6" :title="keyYear + '年6月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month6" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month7" data-index="month7" :title="keyYear + '年7月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month7" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month8" data-index="month8" :title="keyYear + '年8月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month8" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month9" data-index="month9" :title="keyYear + '年9月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month9" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month10" data-index="month10" :title="keyYear + '年10月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month10" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month11" data-index="month11" :title="keyYear + '年11月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month11" disabled></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month12" data-index="month12" :title="keyYear + '年12月'">
                      <template scope="text,record">
                        <a-input class="aInput" v-model="record.month12" disabled></a-input>
                      </template>
                    </a-table-column>
                    <!-- <a-table-column key="action" title="操作" width="240px" v-if="isSettings == false">
                      <template slot-scope="text, record, index">
                        <span v-if="record.parent_id != 0"> -->
                    <!-- <a-button
                            type="primary"
                            @click="addSub(record, index)"
                            v-if="!record.childrens || record.childrens.length == 0"
                            >{{ type == 0 ? '添加子预算' : '查看子预算' }}
                          </a-button> -->
                    <!-- <a @click.stop="removeItemForm(index)">启用</a>
                          <a-divider type="vertical" />
                          <a @click.stop="detail(index)">查看</a>
                          <a-divider type="vertical" />
                          <a @click.stop="edit(index)">编辑</a>
                          <a-divider type="vertical" />
                          <a @click.stop="remove(index)">删除</a> -->
                    <!-- </span>
                      </template>
                    </a-table-column> -->
                  </a-table>
                </div>
              </div>
              <!-- 子预算明细 -->
              <div
                v-if="
                  statisticsList.length &&
                  statisticsList.length < 2 &&
                  statisticsList[0].subsetObjects &&
                  statisticsList[0].subsetObjects.length &&
                  isSettings == false
                "
              >
                <div class="item"><span class="box"></span>子预算明细</div>
                <div  class="subObject" v-if="type == 1">
                  <a-table
                    :data-source="statisticsList[0].subsetObjects"
                    bordered
                    :pagination="false"
                    :scroll="{ x: 5200, y: 490 }"
                  >
                    <a-table-column
                      key="BaseInformation.name"
                      data-index="BaseInformation.name"
                      title="预算范围"
                      v-if="flag == false"
                    >
                      <template scope="text">
                        <div style="display: flex; justify-content: space-between; align-items: center">
                          <span>{{ text }}</span>
                        </div>
                      </template>
                    </a-table-column>
                    <a-table-column key="name" data-index="name" title="预算范围" v-else>
                      <template scope="text">
                        <div style="display: flex; justify-content: space-between; align-items: center">
                          <span>{{ text }}</span>
                        </div>
                      </template>
                    </a-table-column>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年1月' }}</span>
                      <a-table-column key="month1.budget_quota" data-index="month1.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month1.amount_occupied" data-index="month1.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month1.confirmed_quota" data-index="month1.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month1.remaining_quota" data-index="month1.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年2月' }}</span>
                      <a-table-column key="month2.budget_quota" data-index="month2.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month2.amount_occupied" data-index="month2.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month2.confirmed_quota" data-index="month2.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month2.remaining_quota" data-index="month2.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年3月' }}</span>
                      <a-table-column key="month3.budget_quota" data-index="month3.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month3.amount_occupied" data-index="month3.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month3.confirmed_quota" data-index="month3.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month3.remaining_quota" data-index="month3.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年4月' }}</span>
                      <a-table-column key="month4.budget_quota" data-index="month4.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month4.amount_occupied" data-index="month4.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month4.confirmed_quota" data-index="month4.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month4.remaining_quota" data-index="month4.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年5月' }}</span>
                      <a-table-column key="month5.budget_quota" data-index="month5.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month5.amount_occupied" data-index="month5.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month5.confirmed_quota" data-index="month5.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month5.remaining_quota" data-index="month5.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年6月' }}</span>
                      <a-table-column key="month6.budget_quota" data-index="month6.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month6.amount_occupied" data-index="month6.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month6.confirmed_quota" data-index="month6.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month6.remaining_quota" data-index="month6.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年7月' }}</span>
                      <a-table-column key="month7.budget_quota" data-index="month7.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month7.amount_occupied" data-index="month7.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month7.confirmed_quota" data-index="month7.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month7.remaining_quota" data-index="month7.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年8月' }}</span>
                      <a-table-column key="month8.budget_quota" data-index="month8.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month8.amount_occupied" data-index="month8.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month8.confirmed_quota" data-index="month8.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month8.remaining_quota" data-index="month8.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年9月' }}</span>
                      <a-table-column key="month9.budget_quota" data-index="month9.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month9.amount_occupied" data-index="month9.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month9.confirmed_quota" data-index="month9.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month9.remaining_quota" data-index="month9.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年10月' }}</span>
                      <a-table-column key="month1.10.budget_quota" data-index="month10.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month10.amount_occupied" data-index="month10.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month10.confirmed_quota" data-index="month10.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month10.remaining_quota" data-index="month10.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年11月' }}</span>
                      <a-table-column key="month11.budget_quota" data-index="month11.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month11.amount_occupied" data-index="month11.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month11.confirmed_quota" data-index="month11.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month11.remaining_quota" data-index="month11.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                    <a-table-column-group>
                      <span slot="title">{{ keyYear + '年12月' }}</span>
                      <a-table-column key="month12.budget_quota" data-index="month12.budget_quota">
                        <span slot="title">预算金额</span>
                      </a-table-column>
                      <a-table-column key="month12.amount_occupied" data-index="month12.amount_occupied">
                        <span slot="title">占用金额</span>
                      </a-table-column>
                      <a-table-column key="month12.confirmed_quota" data-index="month12.confirmed_quota">
                        <span slot="title">已确认金额</span>
                      </a-table-column>
                      <a-table-column key="month12.remaining_quota" data-index="month12.remaining_quota">
                        <span slot="title">预算余额</span>
                      </a-table-column>
                    </a-table-column-group>
                  </a-table>
                </div>
                <div  class="subObject" v-else>
                  <a-table
                    :data-source="statisticsList[0].subsetObjects"
                    bordered
                    :pagination="false"
                    :scroll="{ x: 2200, y: 490 }"
                  >
                    <a-table-column
                      key="BaseInformation.name"
                      data-index="BaseInformation.name"
                      title="预算范围"
                      v-if="flag == false"
                    >
                      <template scope="text, record">
                        <div style="display: flex; justify-content: space-between; align-items: center">
                          <span>{{ text }}</span>
                          <a-button type="link" icon="close" style="color: red" @click="deleteItem(record)" />
                        </div>
                      </template>
                    </a-table-column>
                    <a-table-column key="name" data-index="name" title="预算范围" v-else>
                      <template scope="text, record">
                        <div style="display: flex; justify-content: space-between; align-items: center">
                          <span>{{ text }}</span>
                          <a-button type="link" icon="close" style="color: red" @click="deleteItem(record)" />
                        </div>
                      </template>
                    </a-table-column>
                    <a-table-column key="month1" data-index="month1" :title="keyYear + '年1月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month1"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month2" data-index="month2" :title="keyYear + '年2月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month2"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month3" data-index="month3" :title="keyYear + '年3月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month3"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month4" data-index="month4" :title="keyYear + '年4月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month4"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month5" data-index="month5" :title="keyYear + '年5月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month5"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month6" data-index="month6" :title="keyYear + '年6月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month6"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month7" data-index="month7" :title="keyYear + '年7月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month7"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month8" data-index="month8" :title="keyYear + '年8月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month8"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month9" data-index="month9" :title="keyYear + '年9月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month9"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month10" data-index="month10" :title="keyYear + '年10月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month10"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month11" data-index="month11" :title="keyYear + '年11月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month11"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                    <a-table-column key="month12" data-index="month12" :title="keyYear + '年12月'">
                      <template scope="text,record">
                        <a-input
                          class="aInput"
                          v-model="record.month12"
                          :disabled="type == 1"
                          oninput="value=value.match(/\d+\.?\d{0,2}/,'')"
                          @change="computedSub"
                        ></a-input>
                      </template>
                    </a-table-column>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'left',
          zIndex: 1,
        }"
      >
        <a-button :style="{ marginRight: '8px' }" type="primary" @click="saveEvent" v-if="type == 0"> 保存 </a-button>
        <a-button :style="{ marginRight: '8px' }" type="primary" @click="submit" v-if="type == 0"> 发布 </a-button>
        <a-button @click="setSub" v-if="type == 0"> 批量设置子集预算 </a-button>
        <a-button @click="importSubbudget" v-if="type == 0"> 导入预算 </a-button>
        <!-- <a-button @click="outputFile" v-if="type == 1"> 导出预算 </a-button> -->
        <a-button @click="outputModelFile" v-if="type == 1"> 导出预算 </a-button>
        <a-button @click="regulate(1)" v-if="regulateData.deptId.length && type == 1"> 手动调剂 </a-button>
        <a-button @click="regulate(2)" v-if="regulateData.deptId.length && type == 1"> 金额修改 </a-button>
        <a-button @click="onClose" type="danger" ghost> 关闭 </a-button>
      </div>
    </a-drawer>
    <a-modal title="费用承担部门设置" :visible="deptVisible" @cancel="closeDept" @ok="addDeptEvent" width="40%">
      <div class="centerBox">
        <div style="margin: 5px">
          <a-input-search
            v-model="queryParam"
            style="width: 70%; margin-bottom: 8px"
            placeholder="请输入名称"
            @change="onChange"
          />
          <!-- <a-button key="back" type="primary" style="margin: 10px 0 0 10px;" @click="allSelect"> 全选 </a-button>
          <a-button key="back" type="primary" style="margin-top: 10px" @click="clearSelect"> 清除全部 </a-button> -->
        </div>
        <div class="bottom">
          <a-tree
            :tree-data="deptTree"
            show-icon
            default-expand-all
            :replace-fields="replaceFields"
            :expanded-keys="expandedKeys"
            :auto-expand-parent="autoExpandParent"
            checkable
            v-model="selectKey"
            @check="onCheck"
            @expand="onExpand"
          >
            <template slot="custom" slot-scope="item">
              <span class="redd" v-if="item.title.indexOf(searchValue) > -1">
                {{ item.title.substr(0, item.title.indexOf(searchValue)) }}
                <span style="color: #f50">{{ searchValue }}</span>
                {{ item.title.substr(item.title.indexOf(searchValue) + searchValue.length) }}
              </span>
              <span v-else>{{ item.title }}</span>
            </template>
          </a-tree>
        </div>
      </div>
    </a-modal>
    <a-modal
      title="修改预算计划名称"
      :visible="editTitleVisible"
      @cancel="closeTitle"
      @ok="editVisibleEvent"
      width="30%"
    >
      <a-form-model :model="titleData" ref="editTitleRef">
        <a-row class="formItem">
          <a-form-model-item label="预算计划名称"
            prop="name"
            :rules="{
              required: true,
              message: '请输入此预算计划名称',
              trigger: 'blur',
            }"
          >
            <!-- <div><span style="color: red">*</span>预算计划名称</div> -->
            <a-input style="width: 70%" v-model="titleData.name" placeholder="请输入此预算计划名称" />
          </a-form-model-item>
        </a-row>
      </a-form-model>
    </a-modal>
    
    <subbudget ref="subbudget" @getCheckoutSub="getCheckoutSub" @addSubValue="addSubValue"></subbudget>
    <importFile ref="importFile" @countDetail="count"></importFile>
    <!-- 手动调剂 -->
    <a-modal
      title="手动调剂"
      :visible="regulateVisible"
      @cancel="closeRegulate"
      @ok="resetRegulate"
      width="60%"
    >
       <div>
          <div style="padding: 5px 0;"><span style="color: red;">*</span> 调剂部门</div>
          <a-cascader style="width: 300px" :field-names="{ label: 'title', value: 'value', children: 'children' }" 
          :options="deptOptions" placeholder="请选择" :show-search="{ filterOption }" v-model="regulateData.deptId" disabled />
      </div>
      <div class="xuxian1"></div>
      <div>
        <div>
            将预算类型中
            <a-cascader style="width: 30%" :options="budgetOptions"  :field-names="{ label: 'name', value: 'id', children: 'child' }"  
            :show-search="{ filterOption }" placeholder="请选择" v-model="regulateData.presentPaymentId" @change="compare" />
            的 
            <a-select show-search allowClear placeholder="请选择" class="margin_self" v-model="regulateData.presentMonth" style="width: 20%;" @change="compare" >
                <a-icon slot="suffixIcon" type="calendar" />
                <a-select-option v-for="(item, index) in dateList" :key="index" :value="item.value">
                    {{ item.title }}
                </a-select-option>
            </a-select>
            预算金额，共计
            <a-input style="width: 20%;" v-model="regulateData.value" placeholder="请输入" @change="compareMoney"
            oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" />元整
            <div style="margin-top: 10px;margin-left: 70%;">（当前剩余预算金额：<span style="color: red;">{{chargeMoney}}</span>元整）</div>
        </div>
        <div style="margin-top: 10px;">
            调整至
        </div>
        <div style="margin-top: 10px;">
          <a-select show-search allowClear placeholder="请选择" class="margin_self" v-model="regulateData.regulateMonth" style="width: 20%;" @change="compareMonth" >
                <a-icon slot="suffixIcon" type="calendar" />
                <a-select-option v-for="(item, index) in dateList" :key="index" :value="item.value">
                    {{ item.title }}
                </a-select-option>
            </a-select>
            预算类型
            <a-cascader style="width: 30%" :options="budgetOptions"  :field-names="{ label: 'name', value: 'id', children: 'child' }" 
             placeholder="请选择" :show-search="{ filterOption }" v-model="regulateData.regulatePaymentId" @change="compareMonth"/>
            中；
        </div>
        
      </div>

    </a-modal>
    <!-- 金额修改 regulateEditVisible-->
    <a-modal
      title="金额修改"
      :visible="regulateEditVisible"
      @cancel="closeRegulateEdit"
      @ok="resetRegulateEdit"
      width="60%"
    >
       <div>
          <div style="padding: 5px 0;"><span style="color: red;">*</span> 调剂部门</div>
          <a-cascader style="width: 300px" :field-names="{ label: 'title', value: 'value', children: 'children' }" 
          :options="deptOptions" placeholder="请选择" :show-search="{ filterOption }" v-model="regulateData.deptId" disabled />
      </div>
      <div class="xuxian1"></div>
      <div>
        <div>
            将预算类型中
            <a-cascader style="width: 30%" :options="budgetOptions"  :field-names="{ label: 'name', value: 'id', children: 'child' }"  
            :show-search="{ filterOption }" placeholder="请选择" v-model="regulateData.presentPaymentId" @change="compare" />
            的 
            <a-select show-search allowClear placeholder="请选择" class="margin_self" v-model="regulateData.presentMonth" style="width: 20%;" @change="compare" >
                <a-icon slot="suffixIcon" type="calendar" />
                <a-select-option v-for="(item, index) in dateList" :key="index" :value="item.value">
                    {{ item.title }}
                </a-select-option>
            </a-select>
            预算金额
            <span style="color: red;">{{chargeMoney? chargeMoney : ' '}}</span>元整
            ，修改为
            <a-input style="width: 20%;" v-model="regulateData.value" placeholder="请输入" 
            oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3')" />元整
            <!-- @change="compareMoney" -->
            <!-- <div style="margin-top: 10px;margin-left: 70%;">（当前剩余预算金额：</div> -->
        </div>
      </div>

    </a-modal>

  </div>
</template>

<script>
import { accAdd } from '@/utils/precision'
import { buildtree, buildFlatten } from '@/utils/amount'
import { templateDetail, addDept, saveModel, publistModel, editName, fileUpload, lookData, deleteArray, getSubBudget, selectMoney, resetMoney, resetMoneyEdit } from '@/api/budget'
import { tree_all } from '@/api/purchase'
import subbudget from './subbudget.vue'
import importFile from './importFile.vue'
import { downLoadXlxs2 } from '@/utils/index'
const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some((item) => item.value === key)) {
        parentKey = node.value
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}
const getParentKey1 = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.childrens) {
      if (node.childrens.some((item) => item.dept_id === key)) {
        parentKey = node.dept_id
      } else if (getParentKey1(key, node.childrens)) {
        parentKey = getParentKey1(key, node.childrens)
      }
    }
  }
  return parentKey
}
export default {
  components: {
    subbudget,
    importFile,
  },
  data() {
    return {
      budgetOptions: [],
      dateList: [{
        value: 1,
        title: '一月'
      },{
        value: 2,
        title: '二月'
      },{
        value: 3,
        title: '三月'
      },{
        value: 4,
        title: '四月'
      },{
        value: 5,
        title: '五月'
      },{
        value: 6,
        title: '六月'
      },{
        value: 7,
        title: '七月'
      },{
        value: 8,
        title: '八月'
      },{
        value: 9,
        title: '九月'
      },{
        value: 10,
        title: '十月'
      },{
        value: 11,
        title: '十一月'
      },{
        value: 12,
        title: '十二月'
      },],
      //剩余金额
      chargeMoney: '',
      //公司部门
      deptOptions: [],
      regulateData: {
        //费用归属部门
        deptId: [],
        //共计金额
        value: '',
        //当前得用类型
        presentPaymentId: [],
        presentMonth: undefined,
        //调剂费用类型
        regulatePaymentId: [],
        regulateMonth: undefined,
      },
      regulateVisible: false,
      regulateEditVisible: false,
      timeout: null,
      // defaultSelectedKeys: [],
      companyDeptName: {},
      expandedKeys1: [],
      searchValue1: '',
      autoExpandParent1: true,
      selectKey: [],
      treeData: [],
      // 0编辑 1详情
      type: '',
      tableScrollY: 1200,
      keyYear: '',
      statisticsList: [],
      titleData: {
        name: '',
      },
      editTitleVisible: false,
      queryParam: '',
      searchValue: '',
      checkedKeys: [],
      autoExpandParent: true,
      deptTree: [],
      deptVisible: false,
      editVisible: false,
      query: {
        name: '',
      },
      deptFields: {
        title: 'dept_name',
        key: 'dept_id',
        children: 'childrens',
      },
      replaceFields: {
        title: 'title',
        key: 'value',
        children: 'children',
      },
      expandedKeys: [],
      prohibitList: [
        {
          id: 1,
          title: '禁止单据提交',
        },
      ],
      prohibit: '',
      checkedSub: [],
      rowData: {},
      child_budget_dimension: '',
      index: '',
      isSettings: true,
      selectedKeys:[]
    }
  },
  created() {},
  watch: {},
  methods: {
    //修改金额弹窗
     resetRegulateEdit() {
      if(this.regulateData.deptId.length >0 &&
        this.regulateData.value != '' &&
        this.regulateData.presentPaymentId.length > 0 &&
        this.regulateData.presentMonth ) {
          resetMoneyEdit({
          // 预算id
          budgetId: this.rowData.id,
          // 部门id
          dept_id: this.regulateData.deptId[this.regulateData.deptId.length-1], 
          // 月份
          month: this.regulateData.presentMonth,
          // money
          budget_quota: this.regulateData.value, 
          // 付款明细id
          type_id: this.regulateData.presentPaymentId[this.regulateData.presentPaymentId.length-1], 
        }).then(res => {
          if(res.code == 200) {
            this.regulateEditVisible = false
            this.regulateData.value = '',
            this.regulateData.presentPaymentId = [],
            this.regulateData.presentMonth = undefined,
            this.regulateData.regulatePaymentId = [],
            this.chargeMoney = ''
            // 刷新页面
            lookData({ id: this.rowData.id }).then((res) => {
              if (res.code == 200) {
                this.$store.commit('LOADING', false)
                var data = res.data
                function slot1(lis) {
                  lis.forEach((item) => {
                    // item['slots'] = item
                    item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
                    if (item.childrens && item.childrens.length) {
                      slot1(item.childrens)
                    }
                  })
                }
                slot1(data)
                this.treeData = res.data
                if(this.treeData.length) {
                  console.log(this.treeData, 'this.treeData====================')
                  var list = []
                  function select(ids, data) {
                      data.forEach(item => {
                        if(item.dept_id == ids[0]) {
                          if(item.childrens && ids.length>1) {
                            ids.splice(0,1)
                            console.log(ids, 'ids=============')
                            select(ids,item.childrens)
                          }else {
                           list[0] = item
                          }
                        }
                    })
                    console.log(list, 'item11111====================')
                    return list
                  }
                  this.isSettings = false
                  var array = JSON.parse(JSON.stringify(this.regulateData.deptId))
                  this.statisticsList =  select(array, this.treeData)
                  console.log(this.statisticsList, 'this.statisticsList===================')
                    
                }
                
              }
            })
          
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)

          }

        })


      } else {
        this.$message.warning('填写数据不能为空！')
      }
      
    },
    //关闭金额修改弹窗
    closeRegulateEdit() {
      this.regulateData.value = '',
      this.chargeMoney = ''
      this.regulateData.presentPaymentId = [],
      this.regulateData.presentMonth = undefined,
      this.regulateEditVisible = false
    },
    compare() {
      this.getMoney()
      this.compareMonth()
    },
    //限制同类型同月份调剂
    compareMonth(){
      console.log(this.regulateData,'2222222222222222222222222222')
      if(this.regulateData.regulatePaymentId.length && this.regulateData.presentPaymentId.length) {
        if(this.regulateData.regulatePaymentId[this.regulateData.regulatePaymentId.length-1] == this.regulateData.presentPaymentId[this.regulateData.presentPaymentId.length-1]) {
          if(this.regulateData.presentMonth == this.regulateData.regulateMonth) {
            this.$message.warning('同类型、同月份不可调剂！')
            this.regulateData.regulateMonth = undefined
          }
        }

      }

    },
    //限制调剂金额
    compareMoney() {
      console.log(this.chargeMoney, this.regulateData.value, 'this.chargeMoney < this.regulateData.value')
      if(Number(this.chargeMoney) < Number(this.regulateData.value)) {
        this.$message.warning('调剂金额不可大于当前剩余预算金额！')
        this.regulateData.value = ''
      } 

    },
    //手动调剂成功
    resetRegulate() {
      if(this.regulateData.deptId.length >0 &&
        this.regulateData.value != '' &&
        this.regulateData.presentPaymentId.length > 0 &&
        this.regulateData.presentMonth &&
        this.regulateData.regulatePaymentId.length > 0 &&
        this.regulateData.regulateMonth  ) {
          resetMoney({
          // 预算id
          id: this.rowData.id,
          // 部门id
          deptId: this.regulateData.deptId[this.regulateData.deptId.length-1], 
          // 月份
          fromMonth: this.regulateData.presentMonth,
          toMonth: this.regulateData.regulateMonth,
          // 付款明细id
          fromTypeId: this.regulateData.presentPaymentId[this.regulateData.presentPaymentId.length-1], 
          toTypeId: this.regulateData.regulatePaymentId[this.regulateData.regulatePaymentId.length-1],
          // 是否为明细 true 为明细
          flag: this.flag, 
          // money
          money: this.regulateData.value, 
        }).then(res => {
          if(res.code == 200) {
            this.regulateVisible = false
            this.regulateData.value = '',
            this.regulateData.presentPaymentId = [],
            this.regulateData.presentMonth = undefined,
            this.regulateData.regulatePaymentId = [],
            this.regulateData.regulateMonth = undefined,
            this.chargeMoney = ''
            // 刷新页面
            lookData({ id: this.rowData.id }).then((res) => {
              if (res.code == 200) {
                this.$store.commit('LOADING', false)
                var data = res.data
                function slot1(lis) {
                  lis.forEach((item) => {
                    // item['slots'] = item
                    item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
                    if (item.childrens && item.childrens.length) {
                      slot1(item.childrens)
                    }
                  })
                }
                slot1(data)
                this.treeData = res.data
                if(this.treeData.length) {
                  console.log(this.treeData, 'this.treeData====================')
                  var list = []
                  function select(ids, data) {
                      data.forEach(item => {
                        if(item.dept_id == ids[0]) {
                          if(item.childrens && ids.length>1) {
                            ids.splice(0,1)
                            console.log(ids, 'ids=============')
                            select(ids,item.childrens)
                          }else {
                           list[0] = item
                          }
                        }
                    })
                    console.log(list, 'item11111====================')
                    return list
                  }
                  this.isSettings = false
                  var array = JSON.parse(JSON.stringify(this.regulateData.deptId))
                  this.statisticsList =  select(array, this.treeData)
                  console.log(this.statisticsList, 'this.statisticsList===================')
                    
                }
                
              }
            })
          
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)

          }

        })


      } else {
        this.$message.warning('填写数据不能为空！')
      }
      
    },
    //获得查看当月预算
    getMoney() {
      console.log('11111111111111111111111111111111111111111111')
      if(this.regulateData.presentPaymentId.length>0 && this.regulateData.presentMonth) {
         selectMoney({
        // 预算id
        id: this.rowData.id,
        // 部门id
        deptId: this.regulateData.deptId[this.regulateData.deptId.length-1], 
        // 月份
        month: this.regulateData.presentMonth, 
        // 付款明细id
        typeId: this.regulateData.presentPaymentId[this.regulateData.presentPaymentId.length-1],
        // 是否为明细 true 为明细
        flag: this.flag,
      }).then(res => {
        if(res.code == 200) {
          this.chargeMoney = res.data
        } else {
          this.$message.error(res.msg)
        }

      })

      }
       
     

    },
    closeRegulate() {
      this.regulateData.value = '',
      this.regulateData.presentPaymentId = [],
      this.regulateData.presentMonth = undefined,
      this.regulateData.regulatePaymentId = [],
      this.regulateData.regulateMonth = undefined,
      this.chargeMoney = ''
      this.regulateVisible = false

    },

    //手动调剂
    regulate(e) {
      // 获得公司部门数据
      tree_all().then((res) => {
        if(res.code == 200) {
            this.deptOptions = res.data[0]
            if(e == 1) {
              this.regulateVisible = true
            } else {
               this.regulateEditVisible = true
            }
        } else {
          this.$message.error(res.msg)
        }
      })
      //获取预算类型
      getSubBudget({
        id: this.rowData.id,
        flag: this.flag
        }).then(res => {
        // this.subTree = res.data
        this.budgetOptions = res.data
        console.log(this.budgetOptions, 'budgetOptions====================')
      })

    },
    //全选公司部门
    allSelect() {
      	var ids = []
        var fids = []
         function getIds(deptTree) {
           	deptTree.forEach(item => {
              ids.push(item.value)
              if(item.children) {
                getIds(item.children)
              }
			    	})
         }
         getIds(this.deptTree)

    },
    //导出模板
    outputModelFile(){
       this.$store.commit('TIPS', '数据较多请耐心等待，不要关闭浏览器')
        if(this.rowData.child_budget_dimension == '各单据模板（费用类型）') {
          this.flag = false
          } else {
          this.flag = true
          }
        downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/act/exportPaymentApplyData')

    },
    //导出
    outputFile() {
       this.$store.commit('TIPS', '数据较多请耐心等待，不要关闭浏览器')
        if(this.rowData.child_budget_dimension == '各单据模板（费用类型）') {
          this.flag = false
          } else {
          this.flag = true
          }
        downLoadXlxs2(process.env.VUE_APP_API_BASE_URL + '/act/budget/out',
            {
                id: this.rowData.id,
                flag: this.flag,
            })
    },
    //删除
    deleteItem(record) {
      console.log('111111111111111111111')
      deleteArray({
        id: record.id,
        ids: this.statisticsList[0].subsetIds
      }).then(res => {
        if(res.code == 200) {
            this.statisticsList[0].subsetIds = res.data
            for (var i = this.statisticsList[0].subsetObjects.length - 1; i >= 0; i--) {
              if (this.statisticsList[0].subsetObjects[i].id == record.id) {
                this.statisticsList[0].subsetObjects.splice(i, 1)
              }
            }
            this.computedSub()
          console.log(this.statisticsList, 'this.statisticsList==============')
          // this.statisticsList[0].
        } else {
          this.$message.error(res.msg)
        }

      })
      // console.log(record, 'record=================')
      // var index =  this.statisticsList[0].subsetIds.indexOf(record.id)
      // console.log(index, 'index===============')
      // if(index >= 0) {
      //   this.statisticsList[0].subsetIds.splice(index, 1)
      // }
      // var index1 =  this.statisticsList[0].subsetIds.indexOf(record.template_id)
      // console.log(index1, 'index1===============')
      // if(index1 >= 0) {
      //   this.statisticsList[0].subsetIds.splice(index1, 1)
      // }

      // for (var j = this.statisticsList[0].subsetIds.length - 1; j >= 0; j--) {
      //   if (this.statisticsList[0].subsetIds[j] == record.id) {
          
      //     console.log(this.statisticsList[0].subsetIds[j], 'this.statisticsList[0].subsetIds[j]====================')
      //     this.statisticsList[0].subsetIds.splice(j, 1)
         
      //   }
      // }
      // console.log(record,this.checkedSub, '=========================')
    
      //    console.log(this.statisticsList[0].subsetIds, 'this.statisticsList[0].subsetIds')
    },
    //子预算计算
    computedSub() {
      console.log(this.statisticsList, 'this.statisticsList[0].subsetObjects==============')
      this.statisticsList.forEach((item1) => {
        var num1 = 0
        var num2 = 0
        var num3 = 0
        var num4 = 0
        var num5 = 0
        var num6 = 0
        var num7 = 0
        var num8 = 0
        var num9 = 0
        var num10 = 0
        var num11 = 0
        var num12 = 0
        item1.subsetObjects.forEach((item) => {
          num1 = accAdd(num1, item.month1)
          num2 = accAdd(num2, item.month2)
          num3 = accAdd(num3, item.month3)
          num4 = accAdd(num4, item.month4)
          num5 = accAdd(num5, item.month5)
          num6 = accAdd(num6, item.month6)
          num7 = accAdd(num7, item.month7)
          num8 = accAdd(num8, item.month8)
          num9 = accAdd(num9, item.month9)
          num10 = accAdd(num10, item.month10)
          num11 = accAdd(num11, item.month11)
          num12 = accAdd(num12, item.month12)
        })
        item1.month1 = num1
        item1.month2 = num2
        item1.month3 = num3
        item1.month4 = num4
        item1.month5 = num5
        item1.month6 = num6
        item1.month7 = num7
        item1.month8 = num8
        item1.month9 = num9
        item1.month10 = num10
        item1.month11 = num11
        item1.month12 = num12
      })
    },
    //计算添加模板之后的所有节点数值
    count() {
      //上传模板之后获得新的树结构
      templateDetail({ id: this.rowData.id }).then((res) => {
        if (res.code == 200) {
          var data = res.data
          function slot1(lis) {
            lis.forEach((item) => {
              // item['slots'] = item
              item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
              if (item.childrens && item.childrens.length) {
                slot1(item.childrens)
              }
            })
          }
          slot1(data)
          function getList(lis) {
            lis.forEach((item) => {
              if (item.childrens && item.childrens.length > 0) {
                getList(item.childrens)
              } else {
                if (item.subsetObjects && item.subsetObjects.length) {
                  var num1 = 0
                  var num2 = 0
                  var num3 = 0
                  var num4 = 0
                  var num5 = 0
                  var num6 = 0
                  var num7 = 0
                  var num8 = 0
                  var num9 = 0
                  var num10 = 0
                  var num11 = 0
                  var num12 = 0
                  item.subsetObjects.forEach((item1) => {
                    num1 = accAdd(num1, item1.month1)
                    num2 = accAdd(num2, item1.month2)
                    num3 = accAdd(num3, item1.month3)
                    num4 = accAdd(num4, item1.month4)
                    num5 = accAdd(num5, item1.month5)
                    num6 = accAdd(num6, item1.month6)
                    num7 = accAdd(num7, item1.month7)
                    num8 = accAdd(num8, item1.month8)
                    num9 = accAdd(num9, item1.month9)
                    num10 = accAdd(num10, item1.month10)
                    num11 = accAdd(num11, item1.month11)
                    num12 = accAdd(num12, item1.month12)
                  })
                  item.month1 = num1
                  item.month2 = num2
                  item.month3 = num3
                  item.month4 = num4
                  item.month5 = num5
                  item.month6 = num6
                  item.month7 = num7
                  item.month8 = num8
                  item.month9 = num9
                  item.month10 = num10
                  item.month11 = num11
                  item.month12 = num12
                }
              }
            })
          }
          getList(res.data)
          this.treeData = res.data
          this.companyDetail()
          // this.treeData
        } else {
          this.$message.error(res.msg)
        }
      })
      //计算树结构数据
    },
    // 修改子预算名称
    editVisibleEvent() {
      console.log(this.titleData.name, 'this.titleData.name============================')
      this.$refs.editTitleRef.validate((valid) => {
        if (valid) {
          editName({
            id: this.rowData.id,
            name: this.titleData.name,
          }).then((res) => {
            if (res.code == 200) {
              this.editTitleVisible = false
              this.rowData.budget_name  = this.titleData.name
              //刷新列表
              this.$emit('changeData')
              this.$message.success(res.msg)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    buildData(item) {
      console.log(item, 'item===================')
      function addData(arr) {
        arr.forEach((em) => {
            for (let i = 1; i <= 12; i++) {
              em['month' + i] = {
                amount_occupied: 0,
                budget_quota: 0,
                confirmed_quota: 0,
                remaining_quota: 0,
              }
            }
          if (em.childrens && em.childrens.length) {
            addData(em.childrens)
          } else {
          
            em.subsetObjects.forEach((sub) => {
              for (let i = 1; i <= 12; i++) {
                console.log(sub['month' + i], 'month' + i)
                em['month' + i].amount_occupied =accAdd(em['month' + i].amount_occupied,sub['month' + i].amount_occupied);
                em['month' + i].budget_quota =accAdd(em['month' + i].budget_quota,sub['month' + i].budget_quota);
                em['month' + i].confirmed_quota =accAdd(em['month' + i].confirmed_quota,sub['month' + i].confirmed_quota);
                em['month' + i].remaining_quota =accAdd(em['month' + i].remaining_quota,sub['month' + i].remaining_quota);
              }
            })
          }
        })
      }
      // console.log(item.childrens, 'item1111===================')
      addData(item)
       console.log(item, 'item===================')
      // return
    },
    companyDetail() {
      console.log('99999999999999999999')
      this.isSettings = true
      if (this.type == 1) {
         this.statisticsList = this.treeData
      } else {
        if (this.treeData && this.treeData.length > 0) {
          this.treeData.forEach((item) => {
            if (item.childrens && item.childrens.length > 0) {
              var num1 = 0
              var num2 = 0
              var num3 = 0
              var num4 = 0
              var num5 = 0
              var num6 = 0
              var num7 = 0
              var num8 = 0
              var num9 = 0
              var num10 = 0
              var num11 = 0
              var num12 = 0
              item.childrens.forEach((item1) => {
                num1 = accAdd(num1, item1.month1)
                num2 = accAdd(num2, item1.month2)
                num3 = accAdd(num3, item1.month3)
                num4 = accAdd(num4, item1.month4)
                num5 = accAdd(num5, item1.month5)
                num6 = accAdd(num6, item1.month6)
                num7 = accAdd(num7, item1.month7)
                num8 = accAdd(num8, item1.month8)
                num9 = accAdd(num9, item1.month9)
                num10 = accAdd(num10, item1.month10)
                num11 = accAdd(num11, item1.month11)
                num12 = accAdd(num12, item1.month12)
              })
              item.month1 = num1
              item.month2 = num2
              item.month3 = num3
              item.month4 = num4
              item.month5 = num5
              item.month6 = num6
              item.month7 = num7
              item.month8 = num8
              item.month9 = num9
              item.month10 = num10
              item.month11 = num11
              item.month12 = num12
            }
          })
          var data = []
          this.treeData.forEach((item) => {
            data.push(item)
          })
          this.statisticsList = data
        }
      }
    },
    addSubValue(data) {
      console.log(data, 'data===================')
      if (data.addType == 1) {
        //批量添加子预算
        function addData(treeData, data) {
          console.log(treeData, 'treeData===================')
          treeData.forEach((item) => {
            if (item.childrens && item.childrens.length > 0) {
              addData(item.childrens, data)
            } else {
              item.month1 = data.num1
              item.month2 = data.num2
              item.month3 = data.num3
              item.month4 = data.num4
              item.month5 = data.num5
              item.month6 = data.num6
              item.month7 = data.num7
              item.month8 = data.num8
              item.month9 = data.num9
              item.month10 = data.num10
              item.month11 = data.num11
              item.month12 = data.num12
              item.subsetIds = data.checkedSub
              item.subsetObjects = JSON.parse(JSON.stringify(data.subList))
            }
          })
        }
        addData(this.treeData, data)
        this.companyDetail()
        // this.saveEvent(false)
      } else {
        this.statisticsList[this.index].month1 = data.num1
        this.statisticsList[this.index].month2 = data.num2
        this.statisticsList[this.index].month3 = data.num3
        this.statisticsList[this.index].month4 = data.num4
        this.statisticsList[this.index].month5 = data.num5
        this.statisticsList[this.index].month6 = data.num6
        this.statisticsList[this.index].month7 = data.num7
        this.statisticsList[this.index].month8 = data.num8
        this.statisticsList[this.index].month9 = data.num9
        this.statisticsList[this.index].month10 = data.num10
        this.statisticsList[this.index].month11 = data.num11
        this.statisticsList[this.index].month12 = data.num12
        this.statisticsList[this.index].subsetIds = data.checkedSub
        this.statisticsList[this.index].subsetObjects = JSON.parse(JSON.stringify(data.subList))
      }
      console.log(this.statisticsList, 'this.statisticsList=======================')
      // this.defaultSelectedKeys = []
      this.selectedKeys=[]
      this.$forceUpdate()
    },
    // 保存模板
    saveEvent(is = true) {
       this.$store.commit('LOADING', true)
      // this.flag = false
      if (this.rowData.child_budget_dimension == '各单据模板（费用类型）') {
        this.flag = false
      } else {
        this.flag = true
      }
      console.log(this.treeData, this.rowData.id, '1111111111111111')
      //增加防抖
      clearTimeout(this.timeout)
       console.log( this.timeout, ' this.timeout=================================')
       this.timeout = setTimeout(() => {
         saveModel({
            is_cumulative: this.rowData.is_cumulative,
            overhead_method: this.prohibit,
            flag: this.flag,
            id: this.rowData.id,
            list: this.treeData,
          }).then((res) => {
            if (res.code == 200) {
              this.expandedKeys1 = []
              this.autoExpandParent1 = false
              this.statisticsList = []
              this.$store.commit('LOADING', false)
              if (is) {
                this.editVisible = false
              }
              this.$message.success(res.msg)
            } else {
              this.$message.error(res.msg)
            }
          })
       },1000)
      
    },
    // addSubValue(data) {
    //   console.log(data, 'data===================')
    //   if (data.addType == 1) {
    //     //批量添加子预算
    //     function addData(treeData, data) {
    //       treeData.forEach((item) => {
    //         if (item.childrens && item.childrens.length > 0) {
    //           addData(item.childrens, data)
    //         } else {
    //           item.month1 = data.num1
    //           item.month2 = data.num2
    //           item.month3 = data.num3
    //           item.month4 = data.num4
    //           item.month5 = data.num5
    //           item.month6 = data.num6
    //           item.month7 = data.num7
    //           item.month8 = data.num8
    //           item.month9 = data.num9
    //           item.month10 = data.num10
    //           item.month11 = data.num11
    //           item.month12 = data.num12
    //           item.subsetIds = data.checkedSub
    //           item.subsetObjects = data.subList
    //         }
    //       })
    //     }
    //     addData(this.treeData, data)
    //     this.companyDetail()
    //   } else {
    //     this.statisticsList[this.index].month1 = data.num1
    //     this.statisticsList[this.index].month2 = data.num2
    //     this.statisticsList[this.index].month3 = data.num3
    //     this.statisticsList[this.index].month4 = data.num4
    //     this.statisticsList[this.index].month5 = data.num5
    //     this.statisticsList[this.index].month6 = data.num6
    //     this.statisticsList[this.index].month7 = data.num7
    //     this.statisticsList[this.index].month8 = data.num8
    //     this.statisticsList[this.index].month9 = data.num9
    //     this.statisticsList[this.index].month10 = data.num10
    //     this.statisticsList[this.index].month11 = data.num11
    //     this.statisticsList[this.index].month12 = data.num12
    //     this.statisticsList[this.index].subsetIds = data.checkedSub
    //     this.statisticsList[this.index].subsetObjects = data.subList
    //   }
    //   console.log(this.statisticsList, 'this.statisticsList=======================')
    //   this.$forceUpdate()
    // },
    //获取子预算
    getCheckoutSub(data) {
      this.checkedSub = data.checkedSub
    },
    //添加子预算
    addSub() {
      this.index = 0
      console.log(this.statisticsList[0], 'this.statisticsList[0]===================')
      this.$refs.subbudget.init({
        type: this.type,
        rowData: this.rowData,
        index: 0,
        record: this.statisticsList[0],
        addType: 0,
      })
    },
    //选择左侧公司部门展示对应数据
    checkDept(checkedKeys, e) {
      this.isSettings = false
      this.regulateData.deptId = []
      console.log(checkedKeys, e.node.dataRef, 'checkedKeys, e============')
      this.companyDeptName = e.node.dataRef;
      //获取公司部门
       if(this.companyDeptName.parent_id != 0) {
        var array = []
        array.push(this.companyDeptName.parent_id)
        array.push(this.companyDeptName.dept_id)
        this.regulateData.deptId = array
        console.log(this.regulateData.deptId,'this.regulateData.deptId=====================')
      }
      this.selectedKeys=checkedKeys
      var data = e.node.dataRef
      if (data.childrens && data.childrens.length) {
        if (this.type == 1) {
          this.statisticsList = data
        } else {
          data.childrens.forEach((item) => {
            if (item.childrens && item.childrens.length > 0) {
              var num1 = 0
              var num2 = 0
              var num3 = 0
              var num4 = 0
              var num5 = 0
              var num6 = 0
              var num7 = 0
              var num8 = 0
              var num9 = 0
              var num10 = 0
              var num11 = 0
              var num12 = 0
              item.childrens.forEach((item1) => {
                num1 = accAdd(num1, item1.month1)
                num2 = accAdd(num2, item1.month2)
                num3 = accAdd(num3, item1.month3)
                num4 = accAdd(num4, item1.month4)
                num5 = accAdd(num5, item1.month5)
                num6 = accAdd(num6, item1.month6)
                num7 = accAdd(num7, item1.month7)
                num8 = accAdd(num8, item1.month8)
                num9 = accAdd(num9, item1.month9)
                num10 = accAdd(num10, item1.month10)
                num11 = accAdd(num11, item1.month11)
                num12 = accAdd(num12, item1.month12)
              })
              item.month1 = num1
              item.month2 = num2
              item.month3 = num3
              item.month4 = num4
              item.month5 = num5
              item.month6 = num6
              item.month7 = num7
              item.month8 = num8
              item.month9 = num9
              item.month10 = num10
              item.month11 = num11
              item.month12 = num12
            }
          })
          this.statisticsList = data.childrens;
          
        }
      } else {
        this.statisticsList = [data]
      }
      
      console.log(this.statisticsList)
      console.log(this.statisticsList, 'statisticsList============')
    },
    getTree() {
      console.log(this.statisticsList)
      console.log(this.treeData)
    },
    //导入预算
    importSubbudget() {
      this.$refs.importFile.init({
        rowData: this.rowData,
      })
    },
    //发布预算
    submit() {
      console.log('2222222222222222')
      publistModel({ id: this.rowData.id }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.expandedKeys1 = []
          this.autoExpandParent1 = false
          //  刷新列表
          this.$emit('changeData')
        } else {
          this.$message.error(res.msg)
        }
        this.statisticsList = []
        this.editVisible = false
      })
    },
    // 批量设置子集预算
    setSub() {
      // type: 1所有公司批量添加 0单个添加
      this.$refs.subbudget.init({
        rowData: this.rowData,
        addType: 1,
        type: 0,
      })
    },
    // 关闭修改预算计划名称弹窗
    closeTitle() {
      this.$refs.editTitleRef.resetFields()
      this.editTitleVisible = false
    },
    //编辑预算计划名称
    editTitle() {
      this.titleData.name = this.rowData.budget_name
      console.log(this.titleData.name, 'this.titleData.name=============')
      this.editTitleVisible = true
    },
    init(data) {
      this.$store.commit('LOADING', true)
      if (data.rowData.child_budget_dimension == '各单据模板（费用类型）') {
        this.flag = false
      } else {
        this.flag = true
      }
      console.log(this.flag, 'this.flag ==================')
      this.isSettings = true
      this.rowData = data.rowData
      this.keyYear = data.rowData.start_year
      this.prohibit = data.rowData.overhead_method
      this.child_budget_dimension = data.rowData.child_budget_dimension
      this.type = data.type
      if (this.type == 0) {
        // 编辑
        // this.type == 0
        templateDetail({ id: data.rowData.id }).then((res) => {
          if (res.code == 200) {
            this.$store.commit('LOADING', false)
            this.editVisible = true
            var data = res.data
            function slot1(lis) {
              lis.forEach((item) => {
                // item['slots'] = item
                item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
                if (item.childrens && item.childrens.length) {
                  slot1(item.childrens)
                }
              })
            }
            slot1(data)
            this.treeData = res.data
            console.log(this.treeData, 'treeDat============')
            if(this.treeData.length) {
              console.log(this.treeData, 'this.treeData====================')
              this.companyDetail()
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        // 详情
        // this.type == 1
        lookData({ id: data.rowData.id }).then((res) => {
          if (res.code == 200) {
            this.$store.commit('LOADING', false)
            this.editVisible = true
            var data = res.data
            function slot1(lis) {
              lis.forEach((item) => {
                // item['slots'] = item
                item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
                if (item.childrens && item.childrens.length) {
                  slot1(item.childrens)
                }
              })
            }
            slot1(data)
            this.treeData = res.data
            if(this.treeData.length) {
              console.log(this.treeData, 'this.treeData====================')
              this.companyDetail()
            }
            
          }
        })
      }
    },
    onClose() {
      this.regulateData.deptId = []
      this.query.name = ''
      this.expandedKeys1 = []
      this.autoExpandParent1 = false
      this.statisticsList = []
      this.$store.commit('TIPS', '加载中......')
      this.editVisible = false
    },
    // 添加公司部门
    addCompeny() {
      if (this.treeData.length) {
        var ids = []
        function selectId(data) {
          console.log(data, 'data=========')
          data.forEach((item) => {
            if (item.childrens && item.childrens.length > 0) {
              selectId(item.childrens)
            } else {
              ids.push(item.dept_id)
            }
          })
        }
        selectId(this.treeData)
        this.selectKey = ids
        console.log(this.selectKey,this.treeData, ' this.selectKey================')
      }

      this.deptVisible = true
      this.getDept()
    },
    getDept() {
      tree_all().then((res) => {
        var data = res.data[0]
        function slot(lis) {
          lis.forEach((item) => {
            // item['slots'] = item
            item['scopedSlots'] = { icon: 'file-text', title: 'custom' }
            if (item.children && item.children.length) {
              slot(item.children)
            }
          })
        }
        slot(data)
        console.log(data)
        this.deptTree = data
      })
      console.log(this.deptTree, 'this.deptTree=====================')
    },
    closeDept() {
      this.selectKey = []
      this.deptVisible = false
    },
    //提交公司部门弹窗
    addDeptEvent() {
      console.log('111111111111111111')
      // this.checkedKeys
      addDept({
        id: this.rowData.id,
        key: this.checkedKeys,
      }).then((res) => {
        console.log(res.data, 'res.data==============')
        var lis = JSON.parse(JSON.stringify(res.data))
        console.log(lis.length, 'lis====================')
        //将左侧树状结构转化为数组
        // 比较数据是否选中
        if (this.treeData.length) {
          var data = buildFlatten(this.treeData)
          var array = []
          //比较两组数据
          data.forEach((item) => {
            lis.forEach((item1) => {
              if (item.dept_id == item1.dept_id) {
                console.log(item, 'item===============')
                array.push(item)
              }
            })
          })
          array.forEach((item) => {
            for (var i = res.data.length - 1; i >= 0; i--) {
              if (item.dept_id == res.data[i].dept_id) {
                res.data.splice(i, 1)
              }
            }
          })
          //  for(var i=res.data.length-1;i>=0; i--) {
          //    array.forEach(item => {
          //      console.log(res.data[i],res.data,i, 'res.data[i]=================')
          //      if(item.dept_id == res.data[i].dept_id) {
          //        res.data.splice(i,1)
          //      }
          //    })
          //  }
          console.log(array, 'array=============')
          var arr = buildtree([...array, ...res.data], [], 0)
          console.log(arr, 'arr========================')
          this.treeData = arr
        } else {
          var arr = buildtree(res.data, [], 0)
          this.treeData = arr
        }

        this.deptVisible = false
        this.selectKey = []
        console.log(arr, 'arr==================')
      })
    },
    //选择公司部门
    onCheck(checkedKeys, e) {
      this.selectKey = checkedKeys
      console.log([...checkedKeys, ...e.halfCheckedKeys], 'checkedKeys====')
      this.checkedKeys = [...checkedKeys, ...e.halfCheckedKeys]
    },
    //抽屉公司部门查询
    search() {
      var dataList = []
      function slot(lis) {
        for (let i = 0; i < lis.length; i++) {
          const node = lis[i]
          const key = lis[i].dept_id
          dataList.push({ key, title: lis[i].dept_name })
          if (node.childrens && node.childrens.length) {
            slot(node.childrens)
          }
        }
      }
      slot(this.treeData)
      console.log(dataList)
      const expandedKeys = dataList
        .map((item) => {
          if (item.title.indexOf(this.query.name) > -1) {
            return getParentKey1(item.key, this.treeData)
          }
          return null
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      this.expandedKeys1 = expandedKeys
      this.searchValue1 = this.query.name
      console.log(this.searchValue1)
        if(this.searchValue1) {
            this.autoExpandParent1 = true
        } else {
          this.expandedKeys1 = []
          this.autoExpandParent1 = false
        }
      console.log(this.autoExpandParent1, this.expandedKeys1, 'this.autoExpandParent1===============')
    },
    //弹窗公司部门查询
    onChange(e) {
      var dataList = []
      function slot(lis) {
        for (let i = 0; i < lis.length; i++) {
          const node = lis[i]
          const key = lis[i].value
          dataList.push({ key, title: lis[i].title })
          if (node.children && node.children.length) {
            slot(node.children)
          }
        }
      }
      slot(this.deptTree)
      console.log(dataList)
      const expandedKeys = dataList
        .map((item) => {
          if (item.title.indexOf(this.queryParam) > -1) {
            return getParentKey(item.key, this.deptTree)
          }
          return null
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      this.expandedKeys = expandedKeys
      this.searchValue = this.queryParam
      console.log(this.searchValue, this.expandedKeys)
      if(this.searchValue) {
          this.autoExpandParent = true
      } else {
        this.expandedKeys = []
         this.autoExpandParent = false
        console.log(this.autoExpandParent,'this.autoExpandParent=====')

      }
      
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onExpand1(expandedKeys) {
      console.log(this.autoExpandParent1, 'this.autoExpandParent1===============')
      this.expandedKeys1 = expandedKeys
      this.autoExpandParent1 = false
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .ant-drawer-body {
  height: calc(100vh - 60px) !important;
  margin-bottom: 45px;
}

.center {
  height: 100%;
  width: 100%;
  .centerTop {
    width: 25%;
    display: inline-block;
    margin: 5px 10px;
  }
  .middleTop {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .centerBottom {
    display: flex;
    // justify-content: space-between;
    .centerLeft {
      width: 25%;
      height: 100%;
      display: inline-block;
      padding: 10px 10px 45px 15px;
      .top {
        padding: 5px;
        border-bottom: 1px solid rgb(196, 195, 195);
      }
    }
    .centerLine {
      height: 100%;
      width: 0;
       border: .5px solid rgb(196, 195, 195);
    }
    .centerRight {
      display: inline-block;
      padding: 10px 10px 55px 15px;
      width: 75%;
      height: 100%;
      .bottom {
        height: 100%;
        .item {
          font-weight: 700;
          color: black;
          font-size: 18px;
          display: flex;
          padding: 10px 0;
          .box {
            align-items: center;
            display: inline-block;
            height: 27px;
            width: 10px;
            margin-right: 5px;
            background-color: #1890ff;
          }
        }
        .itemBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0 0 15px;
          span {
            width: 30%;
          }
          div {
            width: 70%;
          }
        }
      }
    }
  }
}
.ant-tree li .ant-tree-node-content-wrapper:hover .but_operation {
  opacity: 1;
  z-index: 99999;
}
.centerBox {
   height: 600px;
  // width: 68%;
  overflow-y: scroll;
}
.aInput {
  width: 100%;
}
.treeBox {
  // height: 600px;
  height: 600px;
  overflow-y: scroll;
}
.subObject {
  .ant-table-body {
     margin-bottom: 45px;
  }
  
}
.xuxian1 {
    margin: 0 30px;
    width: 100%;
    height:0;
    border-bottom: #BBBBBB  1px dashed;
    margin: 12px 0;

}
</style>